import React from 'react'
import './Career.css'
import aboutimg1 from "../../assets/aboutimg1.png"

const Career = () => {
    return (
        <div>

            <section className="about-section" style={{
                backgroundImage: `url(${aboutimg1})`
            }}>
                <div className="about-container">
                    <div className="about-flex">
                        <div className="about-left">
                            <span className="about-tag">Services</span>
                            <h2 className="about-heading">
                                Careers  <br />
                                {/* <span className="highlighted-text">Ventures Difference</span> */}
                            </h2>
                        </div>
                        <div className="about-right">
                            <p className="about-description">
                                <h3>Unlock a rewarding career with PA Wealth</h3>
                                Where learning meets growth, offering exciting opportunities for professional development and financial success.
                            </p>
                            {/* <div className="about-stats">
                                <div className="stat-block">
                                    <span className="stat-number">4,000<span className="plus">+</span></span>
                                    <div className="stat-label">Happy Investors</div>
                                </div>
                                <div className="stat-block">
                                    <span className="stat-number">20<span className="plus">+</span></span>
                                    <div className="stat-label">Years Experience</div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default Career